export function quotationHistoryReturnUrl(search) {
  const fallback = "/quotations";
  const value = new URLSearchParams(search).get("return");
  if (!value || !value.startsWith("/") || value.startsWith("//")) return fallback;
  try {
    const parsed = new URL(value, "http://flowpi.local");
    if (
      parsed.origin !== "http://flowpi.local" ||
      parsed.pathname !== "/quotations"
    ) {
      return fallback;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}
